import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "services/axios";

  /* -------------------------------------------- Get CostAdjustment Reports List ------------------------------------ */
  export const getCostAdjustmentReportList = createAsyncThunk("costAdjustmentHistory/getCostAdjustmentReportList",  
    async (args, thunkApi) => {
    try {
      const { data } = await axios.get(`https://rostoapi.smartgate-egypt.com/Reports/GetCostAdjustmentReport`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);


 /* --------------------------------------- Inventory Levels Filter Data ------------------------------*/
 export const getCostAdjustmentHistoryFilteredData = createAsyncThunk("costAdjustmentHistory/getCostAdjustmentHistoryFilteredData ", 
  async (args, thunkApi) => {
  try {
    return (args);
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);
export const resetCostAdjustmentHistoryFilteredData = createAsyncThunk( "costAdjustmentHistory/resetCostAdjustmentHistoryFilteredData ", 
  async (args, thunkApi) => { 
  try {
    return args;
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);